export default {
    topics: [
        {
            title: ' AutoDetect ',
            href: 'sm-dataTransfer-AutoDetect.html',
            attributes: { 'data-id': 'sm-dataTransfer-AutoDetect' },
            menu: { hasChildren: false },
            tocID: 'sm-dataTransfer-AutoDetect-d66e417',
            topics: [],
        },
        {
            title: ' Cleanup ',
            href: 'sm-dataTransfer-Cleanup.html',
            attributes: { 'data-id': 'sm-dataTransfer-Cleanup' },
            menu: { hasChildren: false },
            tocID: 'sm-dataTransfer-Cleanup-d66e425',
            topics: [],
        },
        {
            title: ' ExportPreview ',
            href: 'sm-dataTransfer-ExportPreview.html',
            attributes: { 'data-id': 'sm-dataTransfer-ExportPreview' },
            menu: { hasChildren: false },
            tocID: 'sm-dataTransfer-ExportPreview-d66e433',
            topics: [],
        },
        {
            title: ' GetFilesToDownload ',
            href: 'sm-dataTransfer-GetFilesToDownload.html',
            attributes: { 'data-id': 'sm-dataTransfer-GetFilesToDownload' },
            menu: { hasChildren: false },
            tocID: 'sm-dataTransfer-GetFilesToDownload-d66e441',
            topics: [],
        },
        {
            title: ' RejectExport ',
            href: 'sm-dataTransfer-RejectExport.html',
            attributes: { 'data-id': 'sm-dataTransfer-RejectExport' },
            menu: { hasChildren: false },
            tocID: 'sm-dataTransfer-RejectExport-d66e449',
            topics: [],
        },
        {
            title: ' Start ',
            href: 'sm-dataTransfer-Start.html',
            attributes: { 'data-id': 'sm-dataTransfer-Start' },
            menu: { hasChildren: false },
            tocID: 'sm-dataTransfer-Start-d66e457',
            topics: [],
        },
        {
            title: ' TestCalcField ',
            href: 'sm-dataTransfer-TestCalcField.html',
            attributes: { 'data-id': 'sm-dataTransfer-TestCalcField' },
            menu: { hasChildren: false },
            tocID: 'sm-dataTransfer-TestCalcField-d66e465',
            topics: [],
        },
    ],
};

